import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { createRefetchContainer, graphql } from 'react-relay';
import Grid from '@material-ui/core/Grid';
import TableFieldMeta from '../../../common/TableFieldMeta';
import TableButton from '../buttons/TableButton';
import { useCommonStyles } from '../Styles';
import { fromGlobalId, toGlobalId } from '../../../helpers/ID';
import AccountLink from '../links/AccountLink';
import { createQueryRendererProgressV2 } from '../QueryRendererProgressV2';
import TablePaginator from '../TablePaginator';

function AccountSearch(props) {
  const {
    relay,
    filter,
    viewer,
    onSelectItems,
    closeOnSingleSelect,
  } = props;
  filter.setRelay(relay);
  const userDescriber = (accountNode) => {
    if (accountNode.clientaccount) {
      const { userModels } = accountNode.clientaccount;
      return userModels.edges.reduce((v, x) => `${v ? `${v},` : ''}${fromGlobalId(x.node.id)[1]}: ${x.node.email}`, null);
    }
    return '';
  };

  const classes = useCommonStyles();

  const columns = [
    TableFieldMeta.localId,
    TableFieldMeta.field(node => <AccountLink account={node} />, 'Name'),
    TableFieldMeta.field(node => userDescriber(node), 'Users'),
    {
      Header: '',
      id: 'action',
      accessor: node => node,
      Cell: row => (
        <TableButton
          key={row.value.id}
          color="primary"
          onClick={() => {
            if (onSelectItems) {
              onSelectItems([row.value]);
            }
          }}
        >
          Select
        </TableButton>
      ),
    },
  ];

  if (viewer && viewer.contracts && viewer.contracts.edges.length === 1 && closeOnSingleSelect) {
    if (onSelectItems) {
      onSelectItems([viewer.contracts.edges[0].node]);
    }
  }

  //this removes any negative sign on decimal points on a input number.
  function handleKeypress(e) {
    const characterCode = e.key;
    if (characterCode === 'Backspace') {
      return;
    }

    const characterNumber = Number(characterCode);
    if (characterNumber >= 0 && characterNumber <= 9) {
      if (e.currentTarget.value && e.currentTarget.value.length) {
        //
      } else if (characterNumber === 0) {
        e.preventDefault();
      }
    } else {
      e.preventDefault();
    }
  }


  return (
    <div>
      <div className={classes.formControlContainer}>
        <Grid container spacing={2}>
          <Grid item>
            {/* Search */}
            <TextField
              id="standard-helperText"
              label="Custom Search"
              defaultValue=""
              className={classes.formControl}
              helperText="id, name"
              margin="normal"
              onChange={e => filter.updateVar('search', e.target.value)}
            />
          </Grid>

          <Grid item>
            {/* Search */}
            <TextField
              id="account-id-filter"
              label="Account ID"
              className={classes.formControl}
              helperText="id"
              type="number"
              onKeyDown={handleKeypress}
              onChange={(e) => {
                const fVal = e.target.value ? toGlobalId('AccountNode', e.target.value) : null;
                filter.updateVar('accountId', fVal);
              }}
            />
          </Grid>

        </Grid>
      </div>

      <TablePaginator
        columns={columns}
        getDataNode={() => (viewer ? viewer.accounts : null)}
        filter={filter}
      />
    </div>
  );
}


const query = graphql`
  query AccountSearchQuery (
    $first: Int
    $offset: Int
    $search: String
    $accountId: ID
  ) {
    viewer {
      ...AccountSearch_viewer
      @arguments (
        first: $first
        offset: $offset
        search: $search
        accountId: $accountId
      )
    }
  }
`;

const container = createRefetchContainer(
  AccountSearch,
  {
    viewer: graphql`
      fragment AccountSearch_viewer on Query      
      @argumentDefinitions(
        first: {type: Int, defaultValue: 10 }
        offset: {type: Int, defaultValue: 0 }
        search: {type: String}
        accountId: {type: ID}
      ) {
        accounts(
          first: $first
          offset: $offset
          search: $search
          id: $accountId
        ) {
          edges {
            node {
              id
              name
              
              clientaccount {
                id
                userModels {
                  edges {
                    node {
                      id 
                      email
                    }
                  }
                }
              }
              
              tenantaccount {
                id
                tenant {
                  id
                }
              }
            }
          }
          count
        }
      }
    `,
  },
  query,
);

AccountSearch.propTypes = {
  closeOnSingleSelect: PropTypes.bool,
};

AccountSearch.defaultProps = {
  closeOnSingleSelect: false,
};

export default createQueryRendererProgressV2(
  query,
  container,
  {},
  {},
  { debounceFields: ['search', 'accountId'] },
);
